(() => {
  'use strict';
  let timer;
  let headerObserver;
  let marqueeObserver;
  const syncHeader = () => {
    const header = document.querySelector('[data-abl-bf-header]');
    if (header) document.body.style.setProperty('--abl-sale-header-height', `${header.getBoundingClientRect().height}px`);
  };
  const start = () => {
    clearInterval(timer);
    headerObserver?.disconnect();
    marqueeObserver?.disconnect();
    const clocks = [...document.querySelectorAll('[data-abl-bf-clock]')].map(node => ({
      node,
      deadline: Date.parse(node.dataset.deadline),
      units: [...node.querySelectorAll('[data-bf-unit]')]
    }));
    const tick = () => {
      let active = false;
      for (const clock of clocks) {
        if (!Number.isFinite(clock.deadline)) { clock.node.hidden = true; continue; }
        const remaining = Math.max(0, Math.ceil((clock.deadline - Date.now()) / 1000));
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
        for (const unit of clock.units) {
          const next = String(values[unit.dataset.bfUnit]).padStart(2, '0');
          if (unit.textContent !== next) unit.textContent = next;
        }
        active ||= remaining > 0;
      }
      if (clocks.length && !active) {
        document.querySelectorAll('[data-abl-bf-promo]').forEach(node => { node.hidden = true; });
        clearInterval(timer);
        syncHeader();
      }
    };
    tick();
    if (clocks.some(clock => clock.deadline > Date.now())) timer = setInterval(tick, 1000);
    syncHeader();
    const header = document.querySelector('[data-abl-bf-header]');
    if (header && 'ResizeObserver' in window) {
      headerObserver = new ResizeObserver(syncHeader);
      headerObserver.observe(header);
    }
    if ('IntersectionObserver' in window) {
      marqueeObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.toggleAttribute('data-bf-paused', !entry.isIntersecting);
      }));
      document.querySelectorAll('[data-abl-bf-marquee]').forEach(node => marqueeObserver.observe(node));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', start);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); });
  window.addEventListener('pageshow', event => { if (event.persisted) start(); });
})();
